<template>
  <elements-layout
          :extra-filters="extraFilters"
          :table-columns='tableColumns'
          :fetch-data-url='fetchDataUrl'

          :tableRepresentation="true"

          :store-module-name="STORE_MODULE_NAME"
          :store-module-config="STORE_MODULE_CONFIG"

          :addDataSidebarAvailable="$can('create', 'platform')"

  >

    <template #addDataForm>
      <platform-add-update></platform-add-update>
    </template>

    <template #tableCellCustomRepresentations="cell">

        <template v-if="cell.field.key === 'platform'">
            <template v-if="get(cell.item, 'id')">
                <platform-cell :data="cell.item"></platform-cell>
            </template>
            <template v-else>
                {{cell.item}}
            </template>
        </template>
        <template v-else-if="cell.field.key === 'station'">
            <template v-if="get(cell.value, 'id')">
                <station-cell :data="cell.value"></station-cell>
            </template>

        </template>
        <template v-else-if="cell.field.key === 'user'">
            <template v-if="get(cell.value, 'id')">
                <user-cell :user="cell.value"></user-cell>
            </template>

        </template>
    </template>

  </elements-layout>
</template>

<script>

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../platformStoreModule'
  import usePlatform from '../usePlatform'

  import PlatformAddUpdate from '../components/PlatformAddUpdate'

  import get from 'lodash.get'

  import UserCell from "@/views/apps/user/components/UserCell";

  import PlatformCell from "@/views/apps/railway_structure/platform/components/PlatformCell";
    import StationCell from "@/views/apps/railway_structure/station/components/StationCell";

  export default {
    props: {
      // Фильтр приходит из карточки родителя: список внутри вкладки обязан
      // показывать только подчинённые записи, а не всё подряд
      extraFilters: {
        type: Object,
        default: () => ({}),
        required: false,
      },
    },
    components: {
        UserCell,
        StationCell,
      PlatformCell,
      ElementsLayout,
      PlatformAddUpdate,
    },
    setup() {

      const {

        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

      } = usePlatform();

      return {
        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

        STORE_MODULE_NAME,
        STORE_MODULE_CONFIG,

        get,
      }
    },
  }
</script>
